import type { CommonParams } from "src/queries/useCommonQueryParams";

export const AI_CONTEXT_QUERY_PARAMS: (keyof CommonParams)[] = [
  "env_name",
  "app_name",
  "app_pit",
  "task_id",
  "task_name",
  "tf_id",
  "ds_name",
  "timeWindow",
  "appTags",
  "appOwners",
];
